import HolrMediaTable from './HolrMediaTable';

export default HolrMediaTable;
